import countryPhoneCodes from '~/js/modules/country-phone-codes';
import CustomRecaptcha from '~/js/components/form-controls/CustomRecaptcha';
import CountryStateSelector from '~/js/components/form-controls/CountryStateSelector';
import CustomDatePicker from '~/js/components/form-controls/CustomDatePicker';
import '~/js/sections/weddings/includes/stickyNav.js';
import moment from 'moment';

const countries = [
  {
    name: 'Select A Country',
    id: '',
    regionCode: '',
    code: ''
  },
  ...window.beaches_app.page.countries
];


const countriesAgent = countries.filter((value, index) => value.name && index != 0);

// create new array for states and appending a new object that represents default value
const states = [
  ...window.beaches_app.page.states
];


    ReactDOM.render(
    <CustomRecaptcha
     wrapperClassName="xs-12 lg-12"
    />,
    document.getElementById('google-recaptcha')
    );

    ReactDOM.render(
      <CountryStateSelector
        countries={ countries }
        states={ states }
        countryName="country"
        stateName="state"
        stateLabelWrapper="xs-12 sm-12 md-12 lg-3"
        stateInputWrapper="xs-12 sm-12 md-12 lg-9"
        countryLabelWrapper="xs-12 sm-12 md-12 lg-3"
        countryInputWrapper="xs-12 sm-12 md-12 lg-9"
      />,
      document.getElementById('country-state-selector')
    );

        ReactDOM.render(
          <CustomDatePicker
            name="futureWeddingDate"
            inputClassName="checkin-date-input"
            isRequired
            displayPlaceHolder
            displayStringDate={false}
            startDate="01/01/2021"
            
          />,
          document.getElementById('checkin-datepicker')
        );

        ReactDOM.render(
          <CustomDatePicker
            name="checkIn"
            inputClassName="checkin-date-input-2"
            isRequired
            displayPlaceHolder
            displayStringDate={false}
            startDate="01/01/2021"
          />,
          document.getElementById('checkin-datepicker-2')
        );

        ReactDOM.render(
          <CustomDatePicker
            name="checkInOne"
            inputClassName="checkin-date-input-3"
            isRequired
            displayPlaceHolder
            displayStringDate={false}
            startDate="01/01/2021"
          />,
          document.getElementById('checkin-datepicker-3')
        );



        ReactDOM.render(
          <CustomDatePicker
            name="checkInTwo"
            inputClassName="checkin-date-input-4"
            isRequired
            displayPlaceHolder
            displayStringDate={false}
            startDate="01/01/2021"
          />,
          document.getElementById('checkin-datepicker-4')
        );

        
        
        const isAgent = document.getElementById('isAgent');
        const isEmail = document.getElementById('isEmail');
        const isPhone = document.getElementById('country-code');


        //isAgent Validation

        const agencyName = document.getElementById('agencyName');
        const agentName = document.getElementById('agentName');
        const agencyCountry = document.getElementById('agencyCountry');
        const agencyEmail = document.getElementById('agencyEmail');
        const agencyAreaCode = document.getElementById('agencyAreaCode');
        const agencyPhoneNumber = document.getElementById('agencyPhoneNumber');


        function handleRadioClick() {
          if (document.getElementById('travelAgentYes').checked) {
            isAgent.style.display = 'block';

            agencyName.setAttribute("required","");
            agentName.setAttribute("required","");
            agencyCountry.setAttribute("required","");
            agencyEmail.setAttribute("required","");

          } else {
            isAgent.style.display = 'none';
            agencyName.removeAttribute("required");
            agentName.removeAttribute("required");
            agencyCountry.removeAttribute("required");
            agencyEmail.removeAttribute("required");
            agencyAreaCode.removeAttribute("required");
            agencyPhoneNumber.removeAttribute("required");
          }
        }

        function handleEmailClick() {
          if (document.getElementById('agencyCkYes').checked) {
            isEmail.style.display = 'block';
            isPhone.style.display = 'none';
            agencyAreaCode.removeAttribute("required");
            agencyPhoneNumber.removeAttribute("required");
            agencyAreaCode.value = "";
            agencyPhoneNumber.value = "";
            agencyEmail.setAttribute("required","");

          } else {
            isEmail.style.display = 'none';
            isPhone.style.display = 'flex';
            agencyEmail.removeAttribute("required");
            agencyEmail.value = "";
            agencyAreaCode.setAttribute("required","");
            agencyPhoneNumber.setAttribute("required","");

          }
        }

        const radioButtons = document.querySelectorAll('input[name="travelAgent"]');
        radioButtons.forEach(radio => {
          radio.addEventListener('click', handleRadioClick);
        });

        const radioButtons2 = document.querySelectorAll('input[name="agencyCk"]');
        radioButtons2.forEach(radio => {
          radio.addEventListener('click', handleEmailClick);
        });


        const countryCodes = countryPhoneCodes.map(element => `${element.dial_code} - ${element.name}`);
        
        const ukIndex = countryCodes.findIndex(code => code.includes('United Kingdom'));
        
        
        const beforeUK = countryCodes.slice(0, ukIndex + 1);     
        const afterUK = countryCodes.slice(ukIndex + 1);
        
        afterUK.sort((a, b) => {
        
          const nameA = a.split(' - ')[1].toUpperCase();  
          const nameB = b.split(' - ')[1].toUpperCase();
        
          return nameA.localeCompare(nameB);   
        });
        
        const sortedCountryCodes = [...beforeUK, ...afterUK];

    const selectElement = document.getElementById('areaCode');
    const agencyElement = document.getElementById('agencyAreaCode');
  
  sortedCountryCodes.forEach((element) => { 
    let dialCode = element.split(" -");
    selectElement.add(new Option(element, dialCode[0]));
  });

  sortedCountryCodes.forEach((element) => { 
    let dialCode = element.split(" -");
    agencyElement.add(new Option(element, dialCode[0]));
  });

  const selectCountry = document.getElementById('agencyCountry');

  countriesAgent.map(x => x.name).forEach((element) => { 
    selectCountry.add(new Option(element, element));
  });



 
  
// Form validations
import '~/js/modules/fend';
const $inquiryForm = $('.inquiry-registration-form');
const $submitButton = $('.form-submit-button');
const $suscribeCheckbox = $('#subscribeEmail');
const $suscribeHidden = $('#subscribeEmailHidden');
const $expectedDateInput = $('input[name="futureWeddingDate"]');
const $subscribeSms = $("#subscribeSms");
const $subscribeSmsHidden = $("#subscribeSmsHidden");
// console.dir($subscribeSms, $subscribeSmsHidden)
let datepickerErrors = 0;
let errorType;

//Validate whitespaces

const formElement = document.getElementById('inquiry-registration-form'); 

const inputElements = formElement.querySelectorAll('input');

document.querySelector('input[type="number"').addEventListener('input', e => {
  e.target.value = Math.round(e.target.value.replace(/\D/g,''))
});


inputElements.forEach(input => {
  let previousValue = input.value; 

  input.addEventListener('input', function() {
    const trimmedValue = this.value.trim(); 
    if (trimmedValue === '' && this.value !== '') {
      this.value = previousValue;
    } else {
      previousValue = this.value;
    }
  });
});

 //Phone Number and Country Code Validation. Subscribe SMS appears only when Usa is active

 const smsProp = document.querySelector(".sms");
//  console.dir(smsProp);
const countryCode = document.querySelector(".countryCode");
const phoneNumber = document.querySelector(".phoneNum");
 selectElement.addEventListener("change", function(event){
   const isUsa = event.target.selectedOptions[0].innerText.includes("United States");
   const smsCheckBox = document.querySelector("#subscribeSms");
  //  console.log(isUsa);
   if(isUsa){
    //  console.log("UnitedStates");
     smsProp.classList.remove("hideSms");
     smsProp.classList.add("showSms");
     countryCode.classList.remove("prevSec");
     phoneNumber.classList.remove("prevSec");
   }
   else if(!isUsa){
     smsProp.classList.add("hideSms");
     smsProp.classList.remove("showSms");
     countryCode.classList.add("prevSec");
     phoneNumber.classList.add("prevSec");

     if(smsCheckBox.checked===true){
      smsCheckBox.checked = false;
    }
   }
 })


$submitButton.click( () => {

  $('[name=phoneNumber]').val($('[name=mobileNumber]').val());
  
  if ($suscribeCheckbox.is(':checked') === true) {
    $suscribeHidden.prop('disabled', true);
  }else{
    $suscribeHidden.prop('disabled', false);
  }

  if ($subscribeSms.is(':checked') === true) {
    $subscribeSmsHidden.prop('disabled', true);
  } else if($subscribeSms.is(':checked') === true && !isUsa){
    $subscribeSmsHidden.prop('disabled', false);
  } else{
    $subscribeSmsHidden.prop('disabled', false);
  }
 
    if(errorType == 2){
      $('#three-dates-notes').removeClass('hide-field');
      document.getElementById('three-dates-error').innerHTML = 'Blackout Dates are not available.';
      return false;
    }else if(errorType == 3){
      $('#three-dates-notes').removeClass('hide-field');
      document.getElementById('three-dates-error').innerHTML = 'The dates you have requested coincide with your future wedding date, Test-Drive dates cannot fall within 4 months of the future wedding date.';
      return false;
    }else if($travelDates1 && $travelDates2 && $travelDates3 != " ")
    {
       if($travelDates1 == $travelDates2 && $travelDates1 == $travelDates3){
          $('#three-dates-notes').removeClass('hide-field');
          document.getElementById('three-dates-error').innerHTML = 'Please use different dates.';
          return false;
       }else if($travelDates1 == $travelDates2 || $travelDates1 == $travelDates3 || $travelDates2 == $travelDates3){

        $('#three-dates-notes').removeClass('hide-field');
        document.getElementById('three-dates-error').innerHTML = 'Please use different dates.';
        return false;
         }
    }else if($travelDates1 && $travelDates2!= ""){
      if($travelDates1 == $travelDates2){
          $('#three-dates-notes').removeClass('hide-field');
          document.getElementById('three-dates-error').innerHTML = 'Please use different dates.';
          return false;
          }
    }else if($travelDates1 && $travelDates3!= "")
    {
      if($travelDates1 == $travelDates3){
        $('#three-dates-notes').removeClass('hide-field');
        document.getElementById('three-dates-error').innerHTML = 'Please use different dates.';
        return false;
         }
    }else if($travelDates2 && $travelDates3!= "")
    {
      if($travelDates2 == $travelDates3){
        $('#three-dates-notes').removeClass('hide-field');
        document.getElementById('three-dates-error').innerHTML = 'Please use different dates.';
        return false;
      }
    }else{
      return true;
    }

  });

$inquiryForm.fend({
  rules: {
    firstName: 'lettersOnly',
    lastName: 'lettersOnly',
    phoneNumber: 'number',
  },
  isMultiPart: false
});


//Dates validation

const $weddingDate1 = $('.checkin-date-input-2');
const $weddingDate2 = $('.checkin-date-input-3');
const $weddingDate3 = $('.checkin-date-input-4');
const $expectedDate1 = $('.checkin-date-input');

let $travelDates1 = $('[name="checkIn"]').val();
let $travelDates2 = $('[name="checkInOne"]').val();
let $travelDates3 = $('[name="checkInTwo"]').val();

let $travelDatesArray = [$travelDates1, $travelDates2, $travelDates3];

function validateDates(weddingDate, testDriveDate) {

  const checkValidDate = 
      Boolean(weddingDate.diff(testDriveDate, 'months') >= 4);

  let showError = false;

  if(moment(testDriveDate).isValid() && !checkValidDate) {
      showError = true
  }
  return showError
}

function checkExpectedDate() {
  const weddingDate = moment($expectedDateInput[0].value.toString());

  const testDriveDate1 = moment($travelDates1);
  const testDriveDate2 = moment($travelDates2);
  const testDriveDate3 = moment($travelDates3);

  const testDriveValidation1 = validateDates(weddingDate, testDriveDate1);
  const testDriveValidation2 = validateDates(weddingDate, testDriveDate2);
  const testDriveValidation3 = validateDates(weddingDate, testDriveDate3);

  const displayError = testDriveValidation1 || testDriveValidation2 || testDriveValidation3; 

  if(displayError == true){
    errorType = 3;
    datepickerErrors = 1;

    if($expectedDateInput.val() == ""){

      $('#three-dates-notes').removeClass('hide-field');
      document.getElementById('three-dates-error').innerHTML = 'Please choose a Preferred Wedding Date.';
      hasBlackOutDays(datepickerErrors);

    }else{
      $('#three-dates-notes').removeClass('hide-field');
      document.getElementById('three-dates-error').innerHTML = 'The dates you have requested coincide with your future wedding date, Test-Drive dates cannot fall within 4 months of the future wedding date.';
      hasBlackOutDays(datepickerErrors);

    }

  }else{
    datepickerErrors= 0;

    $('#three-dates-notes').addClass('hide-field');
    hasBlackOutDays(datepickerErrors);
  }
}

function hasBlackOutDays(datepickerErrors) {

  const blackoutdays = ['11/19/2023','11/20/2023','11/21/2023','11/22/2023',
                        '12/18/2023','12/19/2023','12/20/2023','12/24/2023',
                        '12/25/2023','12/26/2023','12/27/2023','12/31/2023',
                        '01/01/2024','01/02/2024','01/03/2024','02/18/2024',
                        '02/19/2024','02/20/2024','02/21/2024','03/17/2024',
                        '03/18/2024','03/19/2024', '03/20/2024','03/24/2024',
                        '03/25/2024','03/26/2024', '03/27/2024','03/31/2024',
                        '04/01/2024','04/02/2024', '04/03/2024', '04/07/2024',
                        '04/08/2024','04/09/2024', '04/10/2024','04/14/2024',
                        '11/24/2024','11/25/2024', '11/26/2024','11/27/2024'];

  $travelDatesArray.forEach((date)=>{

    for(let i =0; i <= blackoutdays.length; i++){ 

      if(date == blackoutdays[i]){
        errorType = 2;
        datepickerErrors = 1;
  
        document.getElementById('three-dates-error').innerHTML = 'Blackout Dates are not available.';
        $('#three-dates-notes').removeClass('hide-field');

      }else{
 
        if(!datepickerErrors){  
        errorType = 0;
         datepickerErrors= 0;
         $('#three-dates-notes').addClass('hide-field');
        }
  
      }

    };

  });

}

$weddingDate1.change(() => {
  $travelDatesArray[0] = $('[name="checkIn"]').val();
  $travelDates1 = $('[name="checkIn"]').val();
  checkExpectedDate();
});

$weddingDate2.change(() => {
  $travelDatesArray[1] = $('[name="checkInOne"]').val();
  $travelDates2 = $('[name="checkInOne"]').val();
  checkExpectedDate();
});

$weddingDate3.change(() => {
  $travelDatesArray[2] = $('[name="checkInTwo"]').val();
  $travelDates3 = $('[name="checkInTwo"]').val();
  checkExpectedDate();
});

$expectedDate1.change(() => {
  checkExpectedDate();
});


//Block THU FRI and SAT
const weekday = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const targetNodes = document.getElementsByClassName('rdatez');
const config = { childList: true, subtree: true };

const callback = function(mutationsList, observer) {

  for(let mutation of mutationsList) {
    if (mutation.type === 'childList') {
    // Elements have changed
      for(let i = 0; i < targetNodes.length; i++) {
        const weddingButtons = targetNodes[i].getElementsByClassName('rdatez-day'); 

        if(weddingButtons != null) {
          for (let i = 0; i < weddingButtons.length; i++) {
            const dateString = weddingButtons[i].classList[2].split('-');
            const dateFormat = new Date(dateString[1], dateString[0] - 1, dateString[2]);

            if(dateFormat.getDay() == 4 || dateFormat.getDay() == 5 || dateFormat.getDay() == 6) {
              weddingButtons[i].classList.add('past-day');
              weddingButtons[i].classList.add('after-end');
              weddingButtons[i].disabled = true;
              weddingButtons[i].classList.add('test-drive-calendar-day-buttons');
            }
          }
        }
      }
      break;
    }
  }
};

  for(let i = 1; i < targetNodes.length; i++) {
    const observer = new MutationObserver(callback);
    observer.observe(targetNodes[i], config);
  }





